// extracted by mini-css-extract-plugin
export default {"crumb_wrapper":"crumb_crumb_wrapper__xrqzi","carat":"crumb_carat__ur6bD","crumb_clickable":"crumb_crumb_clickable__UOUOh"};